var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.data.showFooter)?_c('footer',{staticClass:"rn-footer footer-style-default variation-two"},[(_vm.data.showNewsletter)?_c('Newsletter'):_vm._e()],1):_vm._e(),(_vm.data.showCopyright)?_c('Copyright'):_vm._e(),_c('ScrollTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }